<template>
  <div>
    <div class="deemLogo"></div>
    <MainForm
      :name="FORM_NAMES.stpSales"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="Main form title"
    >
      <StepModel
        :ui="uiBaseLogin"
        :name="STEP_NAMES.salesAuto"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
      >
        <FieldsetModel :ui="uiBaseFieldset" name="Showroom" ui-title="Showroom">
          <UiWrapper :name="FIELD_NAMES.channel">
            <Dropdown placeholder="Select Showroom" :options="branches" />
          </UiWrapper>
        </FieldsetModel>

        <FieldsetModel
          :ui="uiBaseFieldset"
          name="businessMangerFiledSet"
          ui-title="Business Manager"
        >
          <UiWrapper
            :name="FIELD_NAMES.salesManager"
            label="Business Manager"
            :validations="[
              {
                errorMessage: 'This field must not be empty',
                condition: notEmptyCondition,
                name: 'businessManagers-filled',
              },
            ]"
          >
            <Suggest
              placeholder="Select Business Manager"
              :exact-match="true"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getManagers"
            />
          </UiWrapper>
          <!-- <UiWrapper
            :name="FIELD_NAMES.salesManager"
            label="Business Manager"
           :validations="[
          {
            'errorMessage': 'Field contains invalid characters',
            'condition': patternCondition(NAME_CHARS_SPACE),
            'name': 'lastname-chars',
          },
        ]"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper> -->
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="salesAgentFieldSet"
          ui-title="Vehicle Model"
        >
          <UiWrapper
            :name="FIELD_NAMES.employeeCode"
            label="Vehicle Model"
            :validations="[
              {
                errorMessage: 'This field must not be empty',
                condition: notEmptyCondition,
                name: 'vehicleModel-filled',
              },
            ]"
          >
            <Suggest
              placeholder="Vehicle Model"
              :exact-match="true"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getSalesAgent"
            />
          </UiWrapper>
          <!-- <UiWrapper
            :name="FIELD_NAMES.employeeCode"
            label="Vehicle Model"
            :validations="addressValidations"
          >
            <InputText  />
          </UiWrapper> -->
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="productType"
          ui-title="Product"
        >
          <UiWrapper :name="FIELD_NAMES.product">
            <Dropdown
              placeholder="Select Product"
              :options="[
                { value: 'New Car', label: 'New Car' },
                { value: 'Used Car', label: 'Used Car' },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <!-- <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.validateOtpFiledSet" ui-title>
          <UiWrapper :name="FIELD_NAMES.validateOTP">
            <Choice
              :options="[
                {
                  value: 'Y',
                  label: 'Generate OTP',
                },
                
              ]"
            />
          </UiWrapper>
        </FieldsetModel> -->
        <!-- <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.promoCodeFields"
          :presence="isOtpValidate"
          ui-columns="2"
        >
          <UiWrapper :name="FIELD_NAMES.otpInput" label="OTP">
            <InputText />
          </UiWrapper>

          <UiWrapper :name="FIELD_NAMES.optValidateButton">
            <Button type="button" color="white" id="generateOtpButton" :click="validateOtp">
              <a href="#">Validate OTP</a>
            </Button>
          </UiWrapper>
        </FieldsetModel> -->
        <!-- <FieldsetModel :ui="uiBaseFieldset" :ui-subtitle="``" name="otpValidateMessage">
          <p hidden class="saving" id="spinner">
            <span class="dot"></span>
            <span class="dotText">Give us few seconds...</span>
          </p>
          <p id="optMessage"></p>
        </FieldsetModel> -->
        <!-- <div v-if="isPhoneFieldVisible"> -->
        <!-- <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.applicationStatusSet"
        >
          <p>
            <button id="btnApplicationStatus" @click="applicationStatusLink">
              <a style href="#">Check Application Satus</a>
            </button>
          </p>
        </FieldsetModel> -->
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.mobile"
          :ui-title="title"
          :ui-subtitle="subtitle"
        >
          <UiWrapper
            :name="FIELD_NAMES.phoneNumber"
            :label="label"
            :validations="validations"
          >
            <InputText type="tel" :prefix="prefix" :maxlength="maxlength" />
          </UiWrapper>
        </FieldsetModel>
        <!-- </div> -->
      </StepModel>
    </MainForm>
  </div>
</template>

<script>
//Global Declaration
let stepToGo = "Welcome";
var productTypes = [];
var employeeCodes = [];
var channels = [];
var salesManagers = [];
let empDetails;
let agentPhoneNumber;

import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import FIELD_NAMES from "@/forms/constants/field-names";
import * as conditions from "@/forms/conditions";
import { patternCondition } from '@/forms/conditions';
import UiWrapper from "@/forms/components/base/ui-wrapper";
import FieldsetModel from "@/lib/components/models/fieldset";
import StepOtp from "@/forms/components/shared/steps/otp";
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import { Dropdown, Button, Suggest, Choice, InputText } from "@dunia/ui";
import autoLoanService from "@/forms/api/services/auto-loan-details";
import setInputFilter from "@/forms/helpers/acceptOnlyNumber";
import {
  SET_EMPLOYEE_CODES,
  SET_AGENT_MOBILE,
  SET_CHANNEL,
} from "@/lib/constants/mutations";
import { any } from "bluebird";
import store from "@/store";
//models
import Product from "@/lib/models/product";
import SalesAgent from "@/lib/models/sales-agent-code";
import SalesManager from "@/lib/models/sales-manager";
import Branch from "@/lib/models/branch";
import otpService from "@/forms/api/services/otp-referral";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import formService from "@/forms/api/services/form";
import {
  MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  DIGIT_CHARS,
  ADDRESS_CHARS,
  NAME_CHARS_SPACE
} from "@/forms/constants/onboarding-logic";
//
export default {
  name: "Referal",

  components: {
    MainForm,
    StepModel,
    Dropdown,
    Button,
    UiWrapper,
    FieldsetModel,
    Suggest,
    Choice,
    InputText,
    FieldsetMobilePhone,
    StepOtp,
    CheckWrapper,
  },
  props: {
    title: {
      type: String,
      default: "Customer Mobile Number",
    },
    subtitle: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Mobile number",
    },
    validations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits",
        },
        {
          errorMessage: "Your phone must start with a 5",
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: "check-is-mobile-starting-number",
        },
        {
          errorMessage: "Your phone must have 9 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: "check-is-mobile-length",
        },
      ],
    },
      addressValidations: {
      type: Array,
      default: () => [
        {
          errorMessage:
            "Field contains invalid characters. Albhabets, Numbers and special character (- , / space) are allowed.",
          condition: patternCondition(ADDRESS_CHARS),
          name: "address-chars",
        },
      ],
    },
    prefix: {
      type: String,
      default: "+971",
    },
    maxlength: {
      type: Number,
      default: 9,
    },
  },
  mixins: [FormComponentMixin],
  data: () => ({
    NAME_CHARS_SPACE,
    emoloyeCode: {
      type: String,
    },
    products: [],
    branches: [],
    employeeCodes: [],
    isPhoneFieldVisible: false,
    disabled: true,
  }),
  async beforeMount() {
    empDetails = await this.getAutoLoanDetails();
    let uniqueBranches = [
      ...new Set(empDetails["emp-details"].map((x) => x.branch)),
    ];
    uniqueBranches.forEach(function (value) {
      channels.push(new Branch(value, value));
    });
    empDetails.products.forEach(function (value) {
      productTypes.push(new Product(value, value));
    });

    this.products = productTypes;
    this.branches = channels;
  },
  async mounted() {
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },

  computed: {
    isSalesManager() {
      return this.fieldValues(FIELD_NAMES.salesManager);
    },
    isEmployeeCode() {
      return this.fieldValues(FIELD_NAMES.employeeCode);
    },
    isOtpValidate() {
      return this.fieldValues(FIELD_NAMES.validateOTP) === "Y";
    },
    isMobileNumber() {
      return this.fieldValues(FIELD_NAMES.phoneNumber);
    },
    isCustomerMobileNumber() {
      return this.$store.state.agentMobileNumber;
    },
    getGenerateOTP() {
      return this.fieldValues(FIELD_NAMES.validateOTP);
    },
  },
  updated: function () {
    var branchDropDown = document.getElementsByName("channel")[0];
    var productDropDown = document.getElementsByName("product")[0];
    var optValidateButton = document.getElementById("generateOtpButton");
    var OtpChoice = document.getElementsByName("validateOTP")[0];
    var buttonReferal = document.getElementById("agentSubmit");

    if (optValidateButton) {
      optValidateButton.style.border = "none";
    }
    if (OtpChoice) {
      if (this.fieldValues(FIELD_NAMES.validateOTP) === "Y") {
        if (document.getElementsByName("phoneNumber")[0]) {
          setInputFilter(
            document.getElementsByName("phoneNumber")[0],
            function (value) {
              return /^\d*?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
            },
            "5"
          );
        }
        // buttonReferal.disabled = true;
      }
    }

    branchDropDown.addEventListener(
      "change",
      function () {
        var selectedValue =
          branchDropDown.options[branchDropDown.selectedIndex].value;
        store.commit(SET_CHANNEL, {
          channel: selectedValue,
        });
        salesManagers = [];
        let employees = [];
        empDetails["emp-details"]
          .filter((emp) => emp.branch === selectedValue)
          .forEach((obj) => {
            employees.push(obj["sales-manager"]);
          });

        employees = employees.reduce((unique, item) => {
          return unique.includes(item) ? unique : [...unique, item];
        }, []);
        employees.forEach((obj) => {
          salesManagers.push(new SalesManager(obj, obj));
        });
      },
      false
    );
    productDropDown.addEventListener(
      "change",
      function () {
        buttonReferal.disabled = true;
      },
      false
    );
  },

  methods: {
    displayText() {
      alert("check box is clicked");
    },
    firstDigit(n) {
      // Remove last digit from number
      // till only one digit is left
      while (n >= 10) n /= 10;

      // return the first digit
      return Math.floor(n);
    },
    async getAutoLoanDetails() {
      var currentStep = this.STEP_NAMES.salesAuto;
      var data = await autoLoanService.getAutoLoanDetails(currentStep, this);
      return data;
    },
    async getManagers(search) {
      let filtered;
      if (search && search !== "") {
        filtered = await salesManagers.filter((Managers) =>
          Managers.label.toUpperCase().includes(search.toUpperCase())
        );
      } else {
        filtered = salesManagers;
      }
      return filtered;
    },
    async getSalesAgent(search) {
      let salesAgentFilter;
      if (search && search !== "") {
        salesAgentFilter = await employeeCodes.filter((EmployeeCode) =>
          EmployeeCode.label.toUpperCase().includes(search.toUpperCase())
        );
      } else {
        salesAgentFilter = employeeCodes;
      }
      return salesAgentFilter;
    },
    //To validate sales agent phone number
    async validateOtp(event) {
      var otpMessage = document.getElementById("optMessage");
      var buttonReferal = document.getElementById("agentSubmit");
      event.preventDefault();
      var otpTextInput = this.fieldValues(FIELD_NAMES.otpInput);
      var channel = this.fieldValues(FIELD_NAMES.channel);
      var currentStep = this.STEP_NAMES.stpSales;
      const spinner = document.getElementById("spinner");

      spinner.removeAttribute("hidden");
      if (otpTextInput) {
        otpMessage.innerHTML = "";
        var response = await otpService.validateAndBlockFields(
          currentStep,
          this
        );

        if (response) {
          //    if(channel.toUpperCase() ==='DSA')
          // {
          //   this.isPhoneFieldVisible = false;
          //    otpMessage.style.color = "#6e3dea";
          //   otpMessage.innerHTML = "OTP has been validated successfully.";
          //    buttonReferal.disabled = false;
          // }
          // else
          // {
          this.isPhoneFieldVisible = true;
          otpMessage.style.color = "#6e3dea";
          otpMessage.innerHTML = "OTP has been validated successfully.";

          // }
        } else {
          this.isPhoneFieldVisible = false;
          buttonReferal.disabled = true;
          otpMessage.style.color = "#ff0000";
          otpMessage.innerHTML = "OTP is wrong.";
        }
      } else {
        otpMessage.style.color = "#ff0000";
        otpMessage.innerHTML = "OTP field must not be empty.";
      }

      spinner.setAttribute("hidden", "");
    },
    gotToWelcome(callback) {
      var product = this.fieldValues(FIELD_NAMES.product);
      var formToGo = "";
      if (product) {
        if (product.toLowerCase() === "stp card") {
          formToGo = "Deem | STP Card";
        }
        if (
          product.toLowerCase() === "stp loan" ||
          product.toLowerCase() === "top up"
        ) {
          formToGo = "Deem | STP Loan";
        }
        if (
          product.toLowerCase() === "New Car" ||
          product.toLowerCase() === "Used Car"
        ) {
          formToGo = "Deem | Auto Sales";
        }
      }
      callback();
      if (formToGo != "") {
        router.goToFormByName(formToGo, {
          stepNameToInit: stepToGo,
        });
      }
    },
    applicationStatusLink(event) {
      event.preventDefault();
      var win = window.open(
        "https://web.deem.io/application-status-sales/",
        "_blank"
      );
      win.focus();
    },
  },
  watch: {
    isSalesManager(value) {
      employeeCodes = [];
      if (value) {
        empDetails["emp-details"]
          .filter((emp) => emp["sales-manager"] === value)
          .forEach((obj) => {
            employeeCodes.push(
              new SalesAgent(obj["emp-code"], obj["emp-code"])
            );
          });
      }
    },
    isEmployeeCode(value) {
      if (value) {
        var objAgent = empDetails["emp-details"].find((obj) => {
          return obj["emp-code"] === value;
        });
        // store.commit(SET_AGENT_MOBILE, {
        //   agentMobileNumber: objAgent["mobile-number"],
        // });
        store.commit(SET_EMPLOYEE_CODES, {
          employeeCodes: this.fieldValues(FIELD_NAMES.employeeCode),
        });
      }
    },
    isOtpValidate(value) {
      if (value) {
        if (this.$store.state.agentMobileNumber) {
          var currentStep = this.STEP_NAMES.stpSales;
          otpService.sendOtp(currentStep, this);
        }
      }
    },

    async isMobileNumber(value) {
      var phoneNumber = document.getElementsByName("phoneNumber")[0];
      var currentStep = this.STEP_NAMES.stpSales;
      var button = document.getElementById("agentSubmit");
      if (phoneNumber) {
        if (value) {
          var isNumber = isNaN(value);
          if (!isNumber && value.length === 9) {
            var firstDigit = this.firstDigit(value);
            if (firstDigit === 5) {
              button.disabled = false;
              await formService.sendFormWithoutBlock();
              await otpService.sendOtpCustomer(currentStep, this);
              // phoneNumber.addEventListener(
              //   "change",

              //   async function() {
              //     await formService.sendFormWithoutBlock();
              //     await otpService.sendOtpCustomer(currentStep, this);
              //   },
              //   false
              // );
            }
          }
        }
      }
    },
    isCustomerMobileNumber(value) {
      if (value) {
        if (this.fieldValues(FIELD_NAMES.validateOTP) === "Y") {
          var currentStep = this.STEP_NAMES.stpSales;
          otpService.sendOtp(currentStep, this);
        }
      }
    },
  },
};
</script>
<style scoped>
@keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}

.saving .dotAnimation {
  /**
     * Use the blink animation, which is defined above
     */
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */

  animation-fill-mode: both;
}

.dot {
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  height: 8px;
  width: 8px;
  background-color: #000000;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}
.dotText {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  color: #9e9e9e;
}
.deemLogo {
  width: 85px;
  height: 35px;
  background-size: 85px 35px;
  top: 30px;
  left: 40px;
  background-position: 0 0;
  background-repeat: no-repeat;
  background-image: url(/img/assets/icons/deemlogo-email.jpg);
  position: absolute;
  /* -webkit-animation: .5s ease 0s normal forwards 1 fadein;
    animation: s ease 0s normal forwards 1 fadein; */
}
#generateOtpButton > a {
  position: relative;
  color: #000000;
  text-decoration: none;
}

#generateOtpButton > a:hover {
  color: #000000;
}
#generateOtpButton > a:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  right: 0;
  background-color: #000000;
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
}

#generateOtpButton > a:hover:before {
  visibility: visible;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}
#btnApplicationStatus > a {
  text-decoration: underline;
  font-weight: bold;
  color: #000000;
}
#btnApplicationStatus > a:hover {
  color: #0000ee;
}
.validationFailed {
  border-color: #f43434;
  background-color: #f43434;
  color: #fff;
}
</style>
